import React from "react";
import { CountrySelect } from "../selectCountry";
import "./selectArea.scss";

export const SelectArea = ({ selectAreaHandler, getAreaItem, setShowSelecttArea }) => {
  const closeSelectAreaHandler = () => { 
    setShowSelecttArea(false);
  }
  return (
    <div className="container-popup" onClick={closeSelectAreaHandler}>
      <CountrySelect
        selectAreaHandler={selectAreaHandler}
        getAreaItem={getAreaItem}
      />
    </div>
  );
};
